// Helper functions for filtering

type TreeNode = {
  name: string;
  children?: TreeNode[];
  toggled?: boolean;
  [key: string]: any;
};

type MatcherFunction = (filterText: string, node: TreeNode) => boolean;

export const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const defaultMatcher: MatcherFunction = (filterText, node) => {
  return node.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1;
};

export const findNode = (node: TreeNode, filter: string, matcher: MatcherFunction): boolean => {
  return (
    matcher(filter, node) || // i match
    (node.children && // or i have decendents and one of them match
      node.children.length &&
      !!node.children.find(child => findNode(child, filter, matcher)))
  );
};

export const filterTree = (node: TreeNode, filter: string, matcher: MatcherFunction = defaultMatcher): TreeNode => {
  // If im an exact match then all my children get to stay
  if (matcher(filter, node) || !node.children) {
    return node;
  }
  // If not then only keep the ones that match or have matching descendants
  const filtered = node.children
    .filter(child => findNode(child, filter, matcher))
    .map(child => filterTree(child, filter, matcher));
  return Object.assign({}, node, { children: filtered });
};

export const expandFilteredNodes = (node: TreeNode, filter: string, matcher: MatcherFunction = defaultMatcher): TreeNode => {
  let children = node.children;
  if (!children || children.length === 0) {
    return Object.assign({}, node, { toggled: false });
  }
  const childrenWithMatches = node.children.filter(child => findNode(child, filter, matcher));
  const shouldExpand = childrenWithMatches.length > 0;
  // If im going to expand, go through all the matches and see if thier children need to expand
  if (shouldExpand) {
    children = childrenWithMatches.map(child => {
      return expandFilteredNodes(child, filter, matcher);
    });
  }
  return Object.assign({}, node, {
    children: children,
    toggled: shouldExpand
  });
};

export const filterTableData = (data: any): any => {
  if (typeof data === "string") {
    if (!isJsonString(data)) return data;
    data = JSON.parse(data);
  }

  if (!Array.isArray(data)) return data;

  let tableData: any[] = [];

  for (let i = 0; i < data.length; i++) {
    let tmpRow: any[] = [];
    for (let j = 0; j < data[i].length; j++) {
      tmpRow.push(data[i][j]);
    }
    tableData.push(tmpRow);
  }

  return tableData;
};
